<template>
	<div>
		<div class="d-flex-between-center m-d-8 align-items-start"
		     v-for="(layanan, i) in transaksi.rincian_layanan" :key="i"
		>
			<div class="d-inline" style="max-width: 70%">
				<div class="f-regular f-14">
						<span class="f-c-black">
							{{ layanan.nama_layanan }}
						</span>
					<span class="f-c-midgrey">  •  {{ layanan.jumlah_beli }} {{ layanan.satuan }}</span>
				</div>

				<div class="border-left m-l-8 m-d-4" style="padding-left: 14px">
					<div class="f-bold f-12 f-c-midgrey" v-if="layanan.mesinable === 0">
						Mesin reguler
					</div>
					<div class="f-regular f-12 f-c-midgrey" v-if="layanan.idmesin !== null">
						<b>Mesin: </b>{{ layanan.mesin }}
					</div>
					<div class="f-12 f-c-midgrey" v-if="layanan.mulai !== ''">
						<b>Mulai: </b>{{ layanan.mulai }}
					</div>
					<div class="f-12 f-c-midgrey" v-if="layanan.selesai !== ''">
						<b>Selesai: </b>{{ layanan.selesai }}
					</div>
				</div>
				<div class="f-regular f-12 f-c-midgrey m-d-4" v-if="layanan.status_mesin === 3">
					<span class="spinner-border spinner-border-sm"
					      role="status"
					      aria-hidden="true"
					></span>
					<span class="m-l-8">Sedang berjalan</span>
				</div>
				<div class="f-regular f-12 f-c-midgrey m-d-4"
				     v-if="transaksi.detail_transaksi.jenis === 2 && layanan.status_mesin >= 3"
				>
					<img src="../../../../assets/icons/user.svg" alt="" class="m-r-4">
					Dikerjakan oleh {{ layanan.karyawan }}
				</div>
				<div class="f-regular f-12 f-c-midgrey m-d-4" v-if="layanan.status_mesin === 1">
					Belum dikerjakan
				</div>
				<div class="f-regular f-12 f-c-green" v-if="layanan.status_mesin === 1">
					Mesin tersedia
				</div>
			</div>
			<div class="f-regular f-14 f-c-black">
				{{ formatRupiah(layanan.harga_satuan.toString()) }}
			</div>
		</div>

		<div class="separator-line-dot m-t-4 m-d-12"></div>
	</div>
</template>

<script>
export default {
	name: "SOTagihanLayananSnapclean",
	props: {
		transaksi: Object
	}
}
</script>